import { provideWorkerReady, WorkerReady } from '@bcf-vanilla-ts-v1-platforms/platform-worker/browser/worker-ready';
import { provideSingleton } from '@bcf-vanilla-ts-v1-shared/di/provide-singleton';
import { browserIdle } from '@bcf-vanilla-ui-ts-v1/shared/ui-rx/browser-idle';
import { EMPTY, first, map, Observable, shareReplay, zip } from 'rxjs';

export class AppLoaded {
  private _readyShareRef$!: Observable<void>;

  constructor(
    private _workerReady: WorkerReady,
    private _window: Window | undefined
  ) {}

  public init(): void {
    if (!this._window) {
      return;
    }
    this.doOnReady().subscribe(() => {
      this._window!.dispatchEvent(new Event('BcfAppLoaded'));
    });
  }

  public doOnReady(): Observable<void> {
    if (!this._window) {
      return EMPTY;
    }
    return (this._readyShareRef$ ??= zip([this._workerReady.isReady$, browserIdle(this._window)]).pipe(
      first(),
      map(() => undefined),
      shareReplay(1)
    ));
  }
}

export function provideAppLoaded(_window: Window | undefined): AppLoaded {
  return provideSingleton(AppLoaded, () => new AppLoaded(provideWorkerReady(), _window));
}
